"use client";

import { getQueryClient } from "@onsand/api";
import { SessionProvider } from "@onsand/auth";
import { Toaster } from "@onsand/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";

export function Providers({ children }: { children: React.ReactNode }) {
	const queryClient = getQueryClient();

	return (
		<ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
			<QueryClientProvider client={queryClient}>
				<SessionProvider>{children}</SessionProvider>
				<Toaster />
			</QueryClientProvider>
		</ThemeProvider>
	);
}
